// Specialization is free text and doctors write it in English, Arabic or Kurdish,
// so matching is done on the spellings that actually show up rather than an enum.
const OB_GYN_PATTERNS = [
    'gyn',          // gyne / gynae / gynec / gynaecology / ob-gyn / obgyn
    'obstetric',
    'نساء',
    'نسائية',
    'ولادة',
    'توليد',
    'ژنان',
    'منداڵبوون'
];

// Obs & Gyn doctors track height and BMI at every visit, so their visit form
// shows those extra vitals.
export const isObGynSpecialization = (user) => {
    const fields = [
        user?.specialization,
        user?.specialization_ar,
        user?.specialization_ku
    ];

    return fields.some((value) => {
        if (!value) return false;
        const text = String(value).toLowerCase();
        if (OB_GYN_PATTERNS.some((pattern) => text.includes(pattern))) return true;
        // "Obs & Gyn" written as just "OBS"
        return /\bobs\b/.test(text);
    });
};
